<template>
  <div class="bookstore-detail">
    <div class="book-introduction">
      <div class="left-demo-card">
        <div class="left-demo-body">
          <div class="left-img-box flex-center">
            <img :src="coverFiles.length > 0 ? coverFiles[currImg].fullUrl : ''" alt="" />
          </div>
          <div class="left-small-img">
            <img v-for="(item, index) in coverFiles" :key="index + Math.random()" :src="item.fullUrl"
              :class="index == currImg ? 'demo-card-box-img-checked' : ''" @click="changeSrc(index)" alt="" />
          </div>
        </div>
      </div>
      <div class="right-info">
        <div class="title">
          <div class="book-label">
            {{ callDictionaries(goodsTypeList, goodsInfo.resourceType) }}
          </div>
          <span>{{ goodsInfo.goodsTitle }}</span>
        </div>
        <div class="book-intro" v-if="goodsInfo.authorRecommendation">
          <div class="defaultIntro" @mouseenter="enterShow" @mouseleave="leaveShow">
            <span class="twointro">{{ goodsInfo.authorRecommendation | ellipsis(120) }}
              <span class="font" v-if="goodsInfo.authorRecommendation.length > 120">更多</span></span>
            <div v-if="showMore" class="allIntro">
              <span>{{ goodsInfo.authorRecommendation }}</span>
            </div>
          </div>
        </div>
        <div class="label">
          <span v-for="(item, index) in keyword" :key="index">{{ item }}</span>
        </div>
        <div class="book-intro-info">
          <div>
            <span>教学属性：</span>
            <span class="ellipsis-aRow">{{
              goodsInfo.teachPropertyAllStr == null ||
                goodsInfo.teachPropertyAllStr == ""
                ? "-"
                : goodsInfo.teachPropertyAllStr
            }}</span>
          </div>
          <div>
            <span>学科：</span>
            <span class="ellipsis-aRow">{{
              goodsInfo.subjectName == null || goodsInfo.subjectName == ""
                ? "-"
                : goodsInfo.subjectName
            }}</span>
          </div>
          <div>
            <span>题目数量：</span>
            <span class="ellipsis-aRow">{{
              goodsInfo.questionCount == null || goodsInfo.questionCount == ""
                ? "-"
                : goodsInfo.questionCount
            }}</span>
          </div>
        </div>
        <div class="select_question">
          <div class="question_flex" v-for="(item, index) in paperTypeList" :key="index">
            <img class="img" src="@/assets/images/tixing.png" />
            <div>
              {{ paperType[Number(item.questionType) - 1].name }}：{{
                item.questionNum
              }}
            </div>
          </div>
        </div>
        <div class="backgroundx"></div>
        <el-button type="primary" @click="questionx(1)" class="question_but but_color_fff">自测模式</el-button>
        <el-button type="warning" @click="questionx(2)" class="question_but but_color_fff">练习模式</el-button>
        <el-button type="primary" v-if="$store.getters.isYuShuYuanUser" plain @click="questionx(3)"
          class="question_but but_color_b">错题本</el-button>
      </div>
    </div>
    <supportingRoll @shoPeiTao="(e) => shoPeiTao = e" />

    <div class="table_list xml-el-tabs-paper-box">
      <el-tabs v-model="activeName">
        <el-tab-pane label="自测历史" name="first">
          <answeringHistory v-if="activeName == 'first'" :goodsId="goodsId" paperType="zcms" :isZiCe="true"
            @upTotal="(e) => { this.total = e }" />
        </el-tab-pane>
        <el-tab-pane v-if="shoPeiTao" label="配套卷答题历史" name="second">
          <answeringHistory v-if="activeName == 'second'" isEquip="1" paperType="peitaojuan" :goodsId="goodsId"
            @upTotal="(e) => { this.total = e }" />
        </el-tab-pane>
      </el-tabs>
      <div class="total-box">答题次数：{{ total }}</div>


    </div>
    <el-dialog title="" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
      <div class="dialog_flex">
        <div>
          <el-button type="primary" class="question_but" @click="practice(0)">顺序练习</el-button>
        </div>
        <div style="margin-top: 20px">
          <el-button type="warning" class="question_but" @click="practice(1)">乱序练习</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="" :visible.sync="dialogVisible1" width="600px" :before-close="handleClose">
      <div class="xml-mode-cards">
        <div class="order-selection">
          <h3 class="order-title">答题模式</h3>
          <div class="order-options">
            <div class="order-option" :class="{ selected: selectedMode === 'single' }" @click="selectMode('single')">
              <!-- <svg class="mode-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M8 3H7a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2h-1"></path>
            <path d="M12 17v.01"></path>
            <path d="M12 14a2 2 0 0 0 1.882-1.348A1.99 1.99 0 0 0 14 12V9a2 2 0 0 0-4 0v3c0 .226.037.444.106.654A2 2 0 0 0 12 14z"></path>
            <rect x="8" y="3" width="8" height="4" rx="1" ry="1"></rect>
          </svg> -->
              <span>单题模式</span>
              <div class="order-radio">
                <div class="order-radio-dot"></div>
              </div>
            </div>

            <div class="order-option" :class="{ selected: selectedMode === 'multiple' }"
              @click="selectMode('multiple')">
              <!-- <svg class="mode-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
            <path d="M15 2H9a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1z"></path>
            <path d="m9 14 2 2 4-4"></path>
          </svg> -->
              <span>多题模式</span>
              <div class="order-radio">
                <div class="order-radio-dot"></div>
              </div>
            </div>
          </div>
        </div>

        <!-- 顺序选择区域 - 只在选择单题或多题模式时显示 -->
        <div v-if="['single', 'multiple'].includes(selectedMode)" class="order-selection">
          <h3 class="order-title">题目顺序</h3>
          <div class="order-options">
            <div class="order-option" :class="{ selected: orderType === 'sequential' }"
              @click="selectOrder('sequential')">
              <svg class="order-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 6h18"></path>
                <path d="M3 12h18"></path>
                <path d="M3 18h18"></path>
              </svg>
              <span>顺序</span>
              <div class="order-radio">
                <div class="order-radio-dot"></div>
              </div>
            </div>

            <div class="order-option" :class="{ selected: orderType === 'random' }" @click="selectOrder('random')">
              <svg class="order-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 20h.01"></path>
                <path d="M7 20v-4"></path>
                <path d="M12 20v-8"></path>
                <path d="M17 20V8"></path>
                <path d="M22 4v16"></path>
              </svg>
              <span>乱序</span>
              <div class="order-radio">
                <div class="order-radio-dot"></div>
              </div>
            </div>
          </div>
        </div>

        <div style="display: flex; width: 370px; margin: 20px auto 0">
          <button v-if="isContinue" class="start-button continue" :class="{ disabled: !selectedMode }"
            :disabled="!selectedMode" @click="startQuiz('continue')">
            继续答题
          </button>
          <button class="start-button" :class="{ disabled: !selectedMode }" :disabled="!selectedMode"
            @click="startQuiz">
            {{ isContinue ? '重新答题' : '开始答题' }}
          </button>
        </div>
      </div>
      <!-- <div class="dialog_flex">
        <div>
          <el-button type="primary" class="question_but" @click="jxAnswer(1)"
            >继续答题</el-button
          >
        </div>
        <div style="margin-top: 20px">
          <el-button type="warning" class="question_but" @click="jxAnswer(2)"
            >创建新练习</el-button
          >
        </div>
      </div> -->
    </el-dialog>

    <el-dialog title="" :visible.sync="dialogVisible2" width="30%" :before-close="handleClose">
      <div class="dialog_flex">
        <div>
          <el-button type="primary" class="question_but" @click="exercise('paginated')">单题练习</el-button>
        </div>
        <div style="margin-top: 20px">
          <el-button type="warning" class="question_but" @click="exercise('scrolled')">多题练习</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="" :visible.sync="dialogVisible3" width="600px" :before-close="handleClose">
      <!-- :filesId="this.filesId" -->
      <div style="overflow-y: scroll;max-height: 600px;">
        <previewBox :subjectId="this.subjectId" :questionCount="this.goodsInfo.questionCount"
          :goodsId="$route.query.goodsId" :bookName="this.$route.query.bookName" :previewMode="this.previewMode">
        </previewBox>
      </div>

      <!-- <integralBox class="topLeft" ref="integralBox"></integralBox> -->
    </el-dialog>
  </div>
</template>
<script>
// import Preview from "@/views/bookstore/answer/preview.vue";

import previewBox from "./preview.vue";
import integralBox from "@/components/integralBox.vue";
import {
  goodsInfoDetail,
  checkIsBuy,
  teachingAttrList,
  isHavingPermissions,
} from "@/api/bookstore/bookstore";
import {
  getAnswerPaperRecord,
  selQuestionTypeAndNumBySubject,
  addPaperApi,
  getUnSubmitPaperRecord,
} from "@/api/answer/answer";
import { paperGetToken, getPaperIdApi, updatePaperId } from "@/api/index/index";
import supportingRoll from '../components/supportingRoll.vue'
import answeringHistory from '../components/answeringHistory.vue'

export default {
  name: "GenerateQuestion",


  data() {
    return {
      dialogVisible: false,
      dialogVisible1: false,
      dialogVisible2: false,
      dialogVisible3: false,
      isContinue: false,
      subjectId: "",
      difen: "",
      showMore: false,
      sourceList: "",
      keyword: [],
      goodsId: null,
      goodsType: null,
      goodsInfo: {}, //商品基本信息
      currImg: 0,
      coverFiles: [], //左侧商品图片数组
      authorList: [], //作者简介
      //查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        answerPlatform: "out",
        paperGenerateMethod: "Zcms",
        paperId: "",
        userId: "",
        token: "",
        params1: "",
      },
      total: 0,
      goodsTypeList: [],
      tableData: [],
      paperTypeList: [],
      paperType: [],
      previewMode: "",
      previewList: {
        single: "paginated",
        multiple: "scrolled",
      },
      selectedMode: "single",
      orderType: "sequential",
      activeName: "first",
      shoPeiTao: false,
    };
  },
  components: { previewBox, supportingRoll, answeringHistory },
  computed: {},
  created() {
    this.$store.commit("subjectId_book", this.$route.query.goodsId);
    this.goodsId = this.$route.query.goodsId;
    this.goodsType = this.$route.query.goodsType;
    this.queryParams.userId = this.$store.state.user.userId;
    this.paperType = this.$store.getters.paperType;
    this.getList();
    this.getoc_resource_file();
  },
  watch: {
    //监听路由变化
    $route() {
      if (this.$route.query.goodsId) {
        this.$store.commit("subjectId_book", this.$route.query.goodsId);
        this.goodsId = this.$route.query.goodsId;
        this.goodsType = this.$route.query.goodsType;
        this.getList();
      }
    },
  },
  methods: {
    selectMode(mode) {
      this.selectedMode = mode;
      // 如果切换到继续答题模式，重置顺序选择
      if (mode === "continue") {
        this.orderType = "sequential";
      }
    },
    selectOrder(order) {
      this.orderType = order;
    },
    startQuiz(e) {
      if (this.selectedMode) {
        this.dialogVisible1 = false;
        // 构建完整的模式信息
        const modeInfo = {
          mode: this.selectedMode,
          order: ["single", "multiple"].includes(this.selectedMode)
            ? this.orderType
            : null,
        };

        // 触发事件，通知父组件所选模式
        // this.$emit('mode-selected', modeInfo);

        // 如果使用 Vue Router，可以这样跳转
        // const query = { mode: this.selectedMode };
        // if (['single', 'multiple'].includes(this.selectedMode)) {
        //   query.order = this.orderType;
        // }
        // this.$router.push({ name: 'quiz', query });

        let modeText = this.getModeText();
        let orderText = this.orderType === "random" ? "乱序" : "顺序";

        if (e === "continue") {
          this.continueAnsweringQuestions();
        } else {
          this.practice();
        }
      }
    },
    checkPreviousSession() {
      // 这里应该是检查本地存储或API以确定是否有未完成的答题记录
      // 示例代码：
      // const savedProgress = localStorage.getItem('quizProgress');
      // this.hasPreviousSession = savedProgress !== null;
    },
    getButtonText() {
      if (this.selectedMode === "continue") {
        return "继续答题";
      } else {
        return "开始答题";
      }
    },
    getModeText() {
      switch (this.selectedMode) {
        case "single":
          return "单题";
        case "multiple":
          return "多题";
        case "continue":
          return "继续";
        default:
          return "";
      }
    },

    exercise(e) {
      this.dialogVisible2 = false;
      // e paginated单题模式 scrolled 多题模式
      this.previewMode = e;
      //questionxType 1自测 2练习 3错题本
      this.question(this.questionxType, e);
    },
    questionx(e) {
      if (e == 3) {
        this.question(e);
        return;
      }
      //questionxType 1自测 2练习 3错题本
      this.questionxType = e;
      // this.dialogVisible2 = true;
      this.question(this.questionxType, "paginated");
    },
    jxAnswer(e) {
      // continue:继续答题 2创建新练习
      // if (this.selectedMode == 'continue') {
      //   this.continueAnsweringQuestions();
      //   this.dialogVisible1 = false;
      // } else {
      //   this.dialogVisible1 = false;
      //   this.dialogVisible = true;
      // }
    },
    testRecord(item) {
      console.log(item);
      this.$router.push({
        path: "/bookstore/answerRecord",
        query: {
          paperId: item.paperId,
          ansRecordId: item.id,
          goodsId: this.$route.query.goodsId,
          bookName: this.$route.query.bookName,
        },
      });
    },
    handleClose() {
      this.dialogVisible = false;
      this.dialogVisible1 = false;
      this.dialogVisible2 = false;
      this.dialogVisible3 = false;
    },
    // 开始练习
    startPracticing() {
      paperGetToken().then((token) => {
        getUnSubmitPaperRecord({
          answerPlatform: "out",
          paperId: "",
          userId: this.$store.getters.userId,
          params1: this.goodsId,
          token: token.data,
        }).then((res) => {
          if (res.code == 200) {
            //有练习记录
            this.isContinue = true;
            this.dialogVisible1 = true;
          } else if (res.code == 205) {
            this.isContinue = false;
            this.dialogVisible1 = true;
          }
        });
      });
    },
    // 继续答题
    continueAnsweringQuestions() {
      let stemSort = {
        sequential: 0,
        random: 1,
      };
      this.$router.push({
        path: "/bookstore/paperAnswer",
        query: {
          answerType: "practice",
          goodsId: this.goodsId,
          typeOk: false,
          bookName: this.$route.query.bookName,
          previewMode: this.previewList[this.selectedMode],
          stemSort: stemSort[this.orderType],
          optionSort: stemSort[this.orderType],
        },
      });
    },
    //练习  创建试卷
    practice() {
      let stemSort = {
        sequential: 0,
        random: 1,
      };
      // let previewMode={
      //   single:'paginated',
      //   multiple:'scrolled'
      // }
      // type 0顺序 1乱序
      this.dialogVisible1 = false;
      this.dialogVisible = false;
      getPaperIdApi().then((paperId) => {
        let data = {
          subjectId: this.subjectId,
          testDuration: "",
          questionNum: this.goodsInfo.questionCount,
          paperGenerateMethod: "lxms",
          createUserId: this.$store.getters.userId,
          testPaperModuleList: [],
          stemSort: stemSort[this.orderType],
          optionSort: stemSort[this.orderType],
          id: paperId.data,
          fullMark: 0,
          passMark: 0,
        };
        console.log("paperId", paperId);
        paperGetToken().then((token) => {
          data.token = token.data;
          addPaperApi(data).then((res) => {
            updatePaperId({ paperId: res.id, goodsId: this.goodsId });
            this.$router.push({
              path: "/bookstore/paperAnswer",
              query: {
                paperId: res.id,
                answerType: "practice",
                goodsId: this.goodsId,
                typeOk: false,
                bookName: this.$route.query.bookName,
                previewMode: this.previewList[this.selectedMode],
              },
            });
          });
        });
      });
    },
    //自测
    question(e, previewMode) {
      //questionxType 1自测 2练习 3错题本
      // paginated单题模式 scrolled 多题模式
      if (e == 1) {
        this.dialogVisible3 = true;
        this.previewMode = previewMode;

        if (this.$route.query.minWin == "1") {
        } else {
        }

        // 俩个路由是一个页面
        // this.$router.push({
        //   path:
        //     this.$route.query.minWin == "1"
        //       ? "/bookstore/previews"
        //       : "/bookstore/preview",
        //   query: {
        //     subjectId: this.subjectId,
        //     questionCount: this.goodsInfo.questionCount,
        //     filesId: this.filesId,
        //     goodsId: this.$route.query.goodsId,
        //     bookName: this.$route.query.bookName,
        //     previewMode: previewMode,
        //   },
        // });
      } else if (e == 2) {
        //判断有无答题记录
        this.startPracticing();
      } else if (e == 3) {
        this.$router.push({
          path:
            this.$route.query.minWin == "1"
              ? "/user/errorBookV2/errDetails"
              : "/user/errorBookV2/errDetail",
          query: {
            title: this.goodsInfo.goodsTitle,
            coverFileUrl: this.coverFiles[0].fullUrl,
            goodId: this.$route.query.goodsId,
            bookName: this.$route.query.bookName,
          },
        });
      }
    },
    enterShow() {
      if (this.goodsInfo.authorRecommendation.length > 135) {
        this.showMore = true;
      }
    },
    leaveShow() {
      this.showMore = false;
    },
    getList() {
      //商品基本信息
      goodsInfoDetail(this.goodsId).then((res) => {
        if (res.code == 200) {
          this.goodsInfo = res.data.goods;
          this.subjectId = this.goodsInfo.subjectId;
          this.sourceList = res.data.sourceList[0];
          if (this.goodsInfo.keyword) {
            this.keyword = this.goodsInfo.keyword.split(",");
          }
          this.coverFiles = res.data.coverFiles;
          if (this.coverFiles.length == 0) {
            let data = {
              fullUrl: require("@/assets/images/default_img.jpg"),
            };
            this.coverFiles.push(data);
          }
          this.authorList = res.data.authorList;
          this.getAnswerPaperRecord();
          this.getQuestionNumber();
          let xiaoZhi = res.data.xiaoZhi;
          // 小智信息存本地
          if (xiaoZhi && xiaoZhi != {}) {
            localStorage.setItem("xiaoZhi", JSON.stringify(res.data.xiaoZhi));
          }
        }
      });
    },

    //获取统计的答卷信息
    getAnswerPaperRecord() {
      // paperGetToken().then((res) => {
      //   this.queryParams.token = res.data;
      //   this.queryParams.params1 = this.goodsId;
      //   getAnswerPaperRecord(this.queryParams).then((res) => {
      //     if (res.code == 200) {
      //       this.tableData = res.rows;
      //       this.total = res.total;
      //     }
      //   });
      // });
    },
    // 根据学科查询题型及题型数量
    getQuestionNumber() {
      paperGetToken().then((token) => {
        selQuestionTypeAndNumBySubject(
          {
            subjectId: this.subjectId,
          },
          token.data
        ).then((res) => {
          this.paperTypeList = res.data || [];
        });
      });
    },

    changeSrc(index) {
      this.currImg = index;
    },
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.getAnswerPaperRecord();
    },
    handleCurrentChange(val) {
      this.queryParams.pageNum = val;
      this.getAnswerPaperRecord();
    },
    getoc_resource_file() {
      //来源
      teachingAttrList("oc_resource_file").then((res) => {
        this.goodsTypeList = res.data;
      });
    },
    // 格式化时间
    getTime(time) {
      if (time) {
        let m = parseInt(time / 60);
        let s = time % 60;
        let date = (m > 9 ? m : "0" + m) + "分" + (s > 9 ? s : "0" + s) + "秒";
        return date;
      } else {
        return "";
      }
    },
  },
};
</script>
<style scoped lang="scss">
.usetime {
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
}

// 响应式 

.bookstore-detail {
  width: 1400px;
  margin: 0 auto;
  height: auto;
  padding-bottom: 40px;
  overflow: hidden;

  .book-introduction {
    display: flex;
    width: 100%;
    min-height: 452px;
    background: #fffefd;
    margin: 0 auto 16px;
    box-sizing: border-box;
    padding: 20px 25px;

    .left-demo-card {
      margin-right: 67px;
      width: 380px;

      .left-demo-body {
        width: 380px;
        height: 380px;
        background: #fff;
        border: 1px solid #f2f2f2;

        .left-img-box {
          width: 280px;
          height: 280px;
          background: #fbfbfb;
          margin: 5px auto 15px;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .left-small-img {
          display: grid;
          grid-column-gap: 5px;
          grid-template-columns: repeat(5, calc(20% - 4px));
          box-sizing: border-box;
          padding: 0 12px;

          img {
            width: 61px;
            height: 61px;
            object-fit: scale-down;
            background: #fbfbfb;
          }

          .demo-card-box-img-checked {
            border: 1px solid #1890ff;
          }
        }
      }

      .left-demo-bottom {
        margin-top: 16px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        >div {
          cursor: pointer;

          img {
            margin-right: 5px;
          }

          display: flex;
          align-items: center;
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #999999;
        }
      }
    }

    .right-info {
      width: 900px;

      .title_info {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 20px;
        padding-bottom: 20px;
      }

      .title {
        display: flex;
        align-items: center;
        margin-bottom: 15px;

        .book-label {
          padding: 0 5px;
          height: 24px;
          background: #f9fdff;
          margin-right: 7px;
          border: 1px solid #0081ce;
          border-radius: 6px;
          font-size: 13px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #0081ce;
          line-height: 24px;
          text-align: center;
        }

        span {
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: 400;
          color: black;
          font-weight: bold;
        }
      }

      .book-intro {
        line-height: 20px;
        margin-bottom: 12px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #666666;

        .defaultIntro {
          position: relative;
          padding: 10px;
          box-sizing: border-box;
        }

        .allIntro {
          position: absolute;
          left: 0;
          top: 0;
          background: #fffefd;
          z-index: 999;
          box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.1);
          border-bottom: 1px solid rgba(0, 0, 0, 0.1);
          padding: 10px;
          box-sizing: border-box;
        }

        .font {
          color: #2e9adb;
          text-decoration: underline;
          cursor: pointer;
        }
      }

      .label {
        display: flex;
        align-items: center;
        margin-bottom: 25px;
        flex-wrap: wrap;

        span {
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #333333;
          background: #f2f2f2;
          border-radius: 6px;
          padding: 7px 10px;
          margin-right: 16px;
          box-sizing: border-box;
          display: block;
          margin-bottom: 8px;
        }

        span:last-child {
          margin-right: 0;
        }
      }

      .book-intro-info {
        width: 850px;
        display: flex;
        align-items: center;
        margin-bottom: 15px;

        >div {
          flex: 1;
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #999999;
          display: flex;
          align-items: center;
        }

        >div:nth-of-type(1) {
          span:last-child {
            width: 200px;
          }
        }

        >div:nth-of-type(2) {
          span:last-child {
            width: 200px;
          }
        }

        >div:nth-of-type(3) {
          span:last-child {
            width: 200px;
          }
        }
      }

      .buttons {
        margin-top: 30px;
      }
    }
  }
}

@media screen and (max-width: 1400px) {
  .bookstore-detail {
    width: calc(100% - 30px);

    .book-introduction {
      .right-info {
        width: calc(100% - 380px);
      }
    }
  }
}

.table_list {
  width: 100%;
  margin: 16px auto 40px auto;
  background: #fffefd;

  .title {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 29px 56px;
    border: #f2f2f2 solid 1px;
  }

  .title1 {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;
    font-family: PingFang SC;
    padding: 20px;
    color: #666666;
  }
}

.pagination-box {
  text-align: right;
  background: #fffefd;
  padding: 25px 0;
}

.underline {
  // font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  text-decoration: underline;
  color: #2e9adb;
  line-height: 17px;
  cursor: pointer;
}

.backgroundx {
  width: 899px;
  height: 2px;
  background: #f2f2f2;
  margin: 15px 0;
}

.select_question {
  width: 100%;
  background: #e5f5ff;
  border-radius: 6px;
  display: flex;
  flex-direction: row;
  align-items: center;
  // justify-content: space-between;
  flex-wrap: wrap;
  padding: 10px;

  .question_flex {
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 9px;
    width: 30%;
    padding: 5px;

    .img {
      width: 14px;
      height: 14px;
    }
  }
}

.question_but {
  width: 202px;
  height: 40px;
}

.but_color_fff {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #ffffff;
}

.but_color_b {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #2e9adb;
}

.dialog_flex {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 200px;
  margin: 0 auto;
}

.paperName_name {
  cursor: pointer;
  color: #2e9adb;
}

.xml-mode-cards {
  --primary-color: #42b983;
  /* 绿色 - 单题模式 */
  --secondary-color: #3490dc;
  /* 蓝色 - 多题模式 */
  --tertiary-color: #9c27b0;
  /* 紫色 - 继续答题 */
  --quaternary-color: #ff9800;
  /* 橙色 - 乱序答题 */
  --quinary-color: #e53935;
  /* 红色 - 顺序答题 */
  --text-color: #2c3e50;
  --light-gray: #f8f9fa;
  --medium-gray: #e9ecef;
  --dark-gray: #6c757d;
  --border-radius: 12px;
  --box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  --transition-time: 0.3s;
}

/* 基础样式 */
.quiz-container {
  font-family: "Helvetica Neue", Arial, sans-serif;
  max-width: 1000px;
  margin: 0 auto;
  padding: 20px;
  color: var(--text-color);
}

.quiz-title {
  text-align: center;
  font-size: 28px;
  margin-bottom: 40px;
  font-weight: 600;
}

/* 卡片容器 */
.mode-cards {
  display: flex;
  justify-content: center;
  gap: 30px;
  margin-bottom: 30px;
  flex-wrap: wrap;
}

/* 响应式布局 */
@media (max-width: 768px) {
  .mode-cards {
    flex-direction: column;
    align-items: center;
  }
}

/* 模式卡片 */
.mode-card {
  position: relative;
  width: 140px;
  padding: 10px;
  background-color: white;
  border-radius: var(--border-radius);
  box-shadow: var(--box-shadow);
  cursor: pointer;
  transition: transform var(--transition-time),
    box-shadow var(--transition-time);
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 2px solid transparent;
}

.mode-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 15px rgba(0, 0, 0, 0.1);
}

.mode-card.selected {
  border-color: var(--primary-color);
  background-color: rgba(66, 185, 131, 0.05);
}

.mode-card:nth-child(2).selected {
  border-color: var(--secondary-color);
  background-color: rgba(52, 144, 220, 0.05);
}

.mode-card:nth-child(3).selected {
  border-color: var(--tertiary-color);
  background-color: rgba(156, 39, 176, 0.05);
}

/* 图标样式 */
.icon-container {
  margin-bottom: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.mode-icon {
  width: 40px;
  height: 40px;
  stroke-width: 2;
  fill: none;
  stroke-linecap: round;
  stroke-linejoin: round;
  transition: stroke var(--transition-time);
}

.mode-card:nth-child(1) .mode-icon {
  stroke: var(--primary-color);
}

.mode-card:nth-child(2) .mode-icon {
  stroke: var(--secondary-color);
}

.mode-card:nth-child(3) .mode-icon {
  stroke: var(--tertiary-color);
}

/* 文字样式 */
.mode-title {
  font-size: 22px;
  font-weight: 600;
  margin-bottom: 10px;
  text-align: center;
}

.mode-description {
  color: var(--dark-gray);
  text-align: center;
  font-size: 16px;
  line-height: 1.5;
  margin-bottom: 20px;
}

/* 单选指示器 */
.radio-indicator {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid var(--medium-gray);
  display: flex;
  justify-content: center;
  align-items: center;
  transition: border-color var(--transition-time);
}

.radio-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: transparent;
  transition: background-color var(--transition-time);
}

.mode-card.selected .radio-indicator {
  border-color: var(--primary-color);
}

.mode-card.selected .radio-dot {
  background-color: var(--primary-color);
}

.mode-card:nth-child(2).selected .radio-indicator {
  border-color: var(--secondary-color);
}

.mode-card:nth-child(2).selected .radio-dot {
  background-color: var(--secondary-color);
}

.mode-card:nth-child(3).selected .radio-indicator {
  border-color: var(--tertiary-color);
}

.mode-card:nth-child(3).selected .radio-dot {
  background-color: var(--tertiary-color);
}

/* 顺序选择区域 */
.order-selection {
  display: flex;
  align-items: center;
  max-width: 600px;
  margin: 0 auto;
  padding: 0 20px 20px 20px;

  animation: fadeIn 0.3s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.order-title {
  font-size: 18px;
  font-weight: 600;
  text-align: center;
}

.order-options {
  display: flex;
  justify-content: center;
  gap: 20px;
  // background-color: var(--light-gray);
  border-radius: var(--border-radius);
  // padding: 20px;
  margin-left: 14px;
}

@media (max-width: 500px) {
  .order-options {
    flex-direction: column;
    align-items: center;
  }
}

/* 顺序选项样式 */
.order-option {
  display: flex;
  align-items: center;
  padding: 10px 20px;
  background-color: white;
  border-radius: 8px;
  border: 1px solid var(--medium-gray);
  cursor: pointer;
  transition: all var(--transition-time);
  width: 160px;
}

.order-option:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05);
}

.order-option.selected:nth-child(1) {
  border-color: var(--quinary-color);
  background-color: rgba(229, 57, 53, 0.05);
}

.order-option.selected:nth-child(2) {
  border-color: var(--quaternary-color);
  background-color: rgba(255, 152, 0, 0.05);
}

.order-icon {
  width: 24px;
  height: 24px;
  stroke-width: 2;
  fill: none;
  stroke-linecap: round;
  stroke-linejoin: round;
  margin-right: 10px;
}

.order-option:nth-child(1) .order-icon {
  stroke: var(--quinary-color);
}

.order-option:nth-child(2) .order-icon {
  stroke: var(--quaternary-color);
}

.order-option span {
  flex-grow: 1;
  font-size: 16px;
  font-weight: 500;
}

/* 顺序选项单选按钮 */
.order-radio {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 2px solid var(--medium-gray);
  display: flex;
  justify-content: center;
  align-items: center;
  transition: border-color var(--transition-time);
}

.order-radio-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: transparent;
  transition: background-color var(--transition-time);
}

.order-option.selected:nth-child(1) .order-radio {
  border-color: var(--quinary-color);
}

.order-option.selected:nth-child(1) .order-radio-dot {
  background-color: var(--quinary-color);
}

.order-option.selected:nth-child(2) .order-radio {
  border-color: var(--quaternary-color);
}

.order-option.selected:nth-child(2) .order-radio-dot {
  background-color: var(--quaternary-color);
}

/* 按钮样式 */
.start-button {
  display: block;
  margin: 0 auto;
  padding: 8px 30px;
  font-size: 16px;
  font-weight: 500;
  color: white;
  background-color: var(--text-color);
  border: none;
  border-radius: 20px;
  cursor: pointer;
  transition: background-color var(--transition-time),
    transform var(--transition-time);
}

.continue {
  background-color: #ffffff;
  color: var(--text-color);
  border: 2px solid var(--text-color);
}

.start-button:hover:not(.disabled) {
  background-color: #1a2533;
  transform: translateY(-2px);
}

.continue:hover:not(.disabled) {
  background-color: #ffffff;
}

.start-button:active:not(.disabled) {
  transform: translateY(0);
}

.start-button.disabled {
  background-color: var(--medium-gray);
  color: var(--dark-gray);
  cursor: not-allowed;
}
</style>
